module.exports = __webpack_public_path__ + "static/img/guide_0.0a8a097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide_0.jpg
// module id = E4w8
// module chunks = 1